import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-page-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin/view.scss */
/* src/app/page.admin/view.scss: no such file or directory */`],
})
export class PageAdminComponent implements OnInit, OnDestroy {
    public tab: string = 'dashboard';
    private routerSub: any;

    // 탭 목록 (구현된 것만 active)
    public tabs: any = {
        dashboard: { label: '대시보드', active: true },
        pipeline: { label: '파이프라인', active: true },
        queries: { label: '질의 로그', active: true },
        tokens: { label: '토큰/비용', active: true },
        models: { label: '모델 설정', active: true },
        settings: { label: '운영 설정', active: true },
        review: { label: '검수 관리', active: true },
        verify: { label: '검증 게이트', active: true },
        terms: { label: '용어 관리', active: true },
        documents: { label: '문서 관리', active: false },
        kg: { label: '지식그래프', active: false },
        users: { label: '사용자 관리', active: false },
        prompts: { label: '프롬프트', active: false },
    };

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this._updateTab();

        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                this._updateTab();
                await this.service.render();
            }
        });

        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private _updateTab() {
        const segment = WizRoute.segment;
        const tab = segment?.tab || 'dashboard';
        if (!this.tabs[tab]) {
            this.service.href('/admin/dashboard');
            return;
        }
        this.tab = tab;
    }
}

export default PageAdminComponent;